import {
  SET_TARGET_STEP,
  ADD_STEP,
  CLONE_STEP,
  DELETE_STEP,
  STEP_CLEAR,
  UPDATE_STEP_ITEMS_LIST,
} from './../_types'
import uidGenerator from '@utils/UIDGenerator'
import arrayToObject from '@utils/arrayToObject'
import objectToArray from '@utils/objectToArray'
import _cloneDeep from 'lodash/cloneDeep'

const getDefaultState = () => {
  return {
    targetStepID: '',
  }
}
export const state = getDefaultState()

export const mutations = {
  [SET_TARGET_STEP](state, id) {
    state.targetStepID = id
  },
  [UPDATE_STEP_ITEMS_LIST](state, { rootState, newList }) {
    rootState.campaign.widget.widgetItems[
      rootState.campaign.widget.targetWidgetID
      ].stepsList = newList
  },
  [ADD_STEP](state, { rootState, newStep, newStepIndex }) {
    rootState.campaign.widget.widgetItems[
      rootState.campaign.widget.targetWidgetID
      ].stepsList.splice(newStepIndex, 0, newStep.id)

    this._vm.$set(
      rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps,
      newStep.id,
      newStep,
    )
  },
  [CLONE_STEP](state, { rootState, cloneStep, cloneStepIndex }) {
    const widgetStepsList =
      rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].stepsList

    this._vm.$set(
      rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps,
      cloneStep.id,
      cloneStep,
    )

    widgetStepsList.splice(cloneStepIndex, 0, cloneStep.id)
  },
  [DELETE_STEP](state, { rootState, id, index }) {
    rootState.campaign.widget.widgetItems[
      rootState.campaign.widget.targetWidgetID
      ].stepsList.splice(index, 1)

    this._vm.$delete(
      rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps,
      id,
    )
  },
  [STEP_CLEAR](state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  setTargetStep({ commit, dispatch }, id) {
    dispatch('campaign/contentItem/clearTargetContentItem', null,
      { root: true })
    dispatch('campaign/widget/undoRedo/clearStacks', null, { root: true })
    commit(SET_TARGET_STEP, id)
  },
  updateStepOrder({ commit, rootState }, newList) {
    commit(UPDATE_STEP_ITEMS_LIST, { rootState, newList })
  },
  addStep({ commit, dispatch, rootState, rootGetters }, index) {
    const newStep = _cloneDeep(
      rootGetters['campaign/widget/getDefaultWidgetTemplateByType'](
        rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].type,
      ).steps[0],
    )

    // Make new ID
    const newID = uidGenerator()
    newStep.id = newID
    const newStepIndex = index + 1

    commit(ADD_STEP, { rootState, newStep, newStepIndex })
    dispatch('setTargetStep', newID)
  },
  cloneStep({ commit, dispatch, state, rootState }, { id, index }) {
    const cloneStep = _cloneDeep(
      rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps[id],
    )
    const cloneStepIndex = index + 1
    const newID = uidGenerator()

    const cloneStepContentItems = objectToArray(cloneStep.contentItems,
      cloneStep.contentItemsList)
    const cloneStepContentItemsList = []

    cloneStepContentItems.forEach((contentItem) => {
      contentItem.id = uidGenerator()
      cloneStepContentItemsList.push(contentItem.id)
    })

    cloneStep.contentItems = arrayToObject(cloneStepContentItems, 'id')
    cloneStep.contentItemsList = cloneStepContentItemsList

    // Clone contentItems
    cloneStep.id = newID
    commit(CLONE_STEP, {
      rootState,
      cloneStep,
      cloneStepIndex,
    })
    dispatch('setTargetStep', newID)
  },
  deleteStep(
    { commit, state, dispatch, rootState, rootGetters }, { id, index }) {
    const targetWidget = rootGetters['campaign/widget/targetWidget']
    if (targetWidget.stepsList.length > 1) {
      if (state.targetStepID === id) {
        // change targetStepID
        const newTargetID =
          rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].stepsList[
            index === 0 ? index + 1 : index - 1
            ]
        dispatch('setTargetStep', newTargetID)
      }

      commit(DELETE_STEP, {
        rootState,
        id,
        index,
      })
    }
  },
  clearStepState({ commit }) {
    commit(STEP_CLEAR)
  },
}
